var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.0003 17.8327C5.39795 17.8327 1.66699 14.1017 1.66699 9.49935C1.66699 7.17223 2.62087 5.06791 4.15896 3.55604M10.0003 17.8327C9.1978 17.238 9.32591 16.5456 9.72853 15.8533C10.3475 14.7889 10.3475 14.7889 10.3475 13.3697C10.3475 11.9505 11.1908 11.2851 14.167 11.8803C15.5043 12.1478 16.4787 10.3001 18.2147 10.9102M10.0003 17.8327C14.1218 17.8327 17.5445 14.8407 18.2147 10.9102M18.2147 10.9102C18.2929 10.4516 18.3337 9.98023 18.3337 9.49935C18.3337 5.43149 15.419 2.04439 11.5641 1.31251M11.5641 1.31251C11.9896 2.096 11.8183 3.02894 10.9193 3.38517C9.4527 3.96626 10.5027 5.03554 9.25321 5.69569C8.42019 6.13578 7.17066 6.02561 5.92113 4.70532C5.26296 4.00988 4.8667 3.63072 4.15896 3.55604M11.5641 1.31251C11.0576 1.21634 10.5348 1.16602 10.0003 1.16602C7.72507 1.16602 5.66278 2.07785 4.15896 3.55604",
    stroke: "#337CC1",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarth);
export default __webpack_public_path__ + "static/media/earth.1a4576724bbffe9471f5f6468ba57d4a.svg";
export { ForwardRef as ReactComponent };